// extracted by mini-css-extract-plugin
export default {"loading":"StoryLoading_loading__U3lt5","animation":"StoryLoading_animation__TYD5t","title":"StoryLoading_title__38osv"};